<template>
    <div class="row">
        <div class="col-12">
            <div class="card mb-2">
                <div class="card-body pb-0" >
                    <div class="row">
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-school color-theme mr-1"></i><span class="font-17"> Nome da escola:</span></label>
                            <input type="text" class="form-control required rounded" maxlength="200"  placeholder="Coloque o nome da escola aqui" v-model="escola.nome" />  
                        </div>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-map-marker-alt color-theme mr-1"></i><span class="font-17"> Cidade:</span></label>
                            <input type="text" class="form-control required rounded" maxlength="200"  placeholder="Cidade onde fica a escola" v-model="escola.endereco" />  
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="enviar()">
                                <span class="font-15 font-weight-bold"><i class="fas fa-plus mr-1"></i>Adicionar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import { mapState } from 'vuex'

export default {
	name: 'CriarEscola',
    data() {
        return {
            escola: {
                nome: '',
                endereco: '',
            },
        };
    },
    computed: {
      ... mapState({
         urlRest: state => state.urlRest
      })
    },
    methods: {
        adicionarOpcao() {
            this.criar.alternativas.push({ opcao: null , habilitaDescritiva: false});
            this.travaBtn += 1
        },
        removerOpcao() {
            this.criar.alternativas.pop();
            this.travaBtn -= 1
        },
        limparCampos() {
            this.escola.nome = '',
            this.escola.endereco = ''
        },
        enviar() {
            let ref = this;
            
            if (this.escola.nome != '') {
                this.$axios({
                    method: 'post',
                    url: this.urlRest +'service/addEscola',
                    headers: {
                        'Content-Type': 'application/json'
                    },

                    data: this.escola
                }).then(function () {
                    ref.$toast.fire({
                        icon: 'success',
                        title: 'Escola adicionada!',
                        timer: 2000,
                    }),
                    ref.limparCampos();
                }).catch(function (error) {
                    if (error.response != undefined) {
                        if (error.response.status == 408) {
                            ref.$store.dispatch('deslogar')

                            ref.$toast.fire({
                                icon: 'warning',
                                title: 'Sessão expirada!'
                            });
                        } else {
                            ref.$toast.fire({
                                icon: 'error',
                                title: 'Erro: ' + error.response.status
                            })
                        }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                    
                }); 
            } else {
                ref.$toast.fire({
                    icon: 'warning',
                    title: 'Preencha o nome da escola',
                    timer: 2000,
                })
            }
        },
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkWindowSize);
    }
}
    
</script>

<style scoped>
    .text-icon {
        margin-top: 2.5px;
    }

   .switch input[type="checkbox"]:not(:checked) + .slider {
      background-color: #3c3e42
   }
   input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(50%);
   }
    .slide-up-enter-active {
        transition: all 0.4s;
    }

    .slide-up-enter {
        transform: translateY(-100%);
        opacity: 0;
    }

    .slide-up-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

    .ajusteBtn {
      margin-top: 32px;
   }

   .container_marker input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.container_marker {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  border-radius: 50%;
  background-color: rgb(78, 78, 78);
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1em;
  width: 1em;
  transition: .3s;
  transform: scale(0);
  border-radius: 50%;
}

/* When the checkbox is checked, add a blue background */
.container_marker input:checked ~ .checkmark {
  background-color: #2096c5;
  transform: scale(1);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_marker input:checked ~ .checkmark:after {
  display: block;
}

.container_marker input:checked ~ .celebrate {
  display: block;
}

/* Style the checkmark/indicator */
.container_marker .checkmark:after {
  left: 7px;
  top: 0.25em;
  width: 0.30em;
  height: 0.5em;
  border: solid rgb(255, 255, 255);
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.container_marker .celebrate {
  position: absolute;
  transform-origin: center;
  animation: kfr-celebrate .4s;
  animation-fill-mode: forwards;
  display: none;
  stroke: #0392CF;
}

@keyframes kfr-celebrate {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
    display: none;
  }
}


</style>